export const calculate1RM = (weight: string, reps: string) => {
  if (Number(reps) === 1) return weight.toString();
  return (Number(weight) * (1 + Number(reps) / 30)).toFixed(2);
};
